import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Fragment } from 'react';

interface CheckBoxInputProps {
    label?: string;
    name: string; // name is required for form tracking
    value: boolean; // Ensure value is boolean for checkbox checked state
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // Correct type for handleChange
    disabled?: boolean;
}

const CheckBoxInput: React.FC<CheckBoxInputProps> = ({
    label = 'Custom checkbox',
    name,
    value,
    handleChange,
    disabled,
}) => {
    return (
        <Fragment>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            name={name} // Name is required for Formik to track field
                            checked={value} // Checked is controlled by the value
                            onChange={handleChange} // Handle change event
                            size="small"
                            disabled={disabled ||false}
                            className="dark:text-green-600 !text-green-500"
                            sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                    color: "#9ca3af",
                                    fontFamily: 'Public Sans, sans-serif',
                                    fontSize: "12px",
                                    fontWeight: 400,
                                },
                            }}
                        />
                    }
                    label={label}
                />
            </FormGroup>
        </Fragment>
    );
};

export default CheckBoxInput;
